/**
 * Returns the csrf token from the document
 *
 * Using this function allows you to mock out the csrf token fetching
 */

export default function getCsrfToken() {
  return document.querySelector('[name=csrfmiddlewaretoken]')?.value;
}
